import React from 'react';
import clsx from 'clsx';

/* eslint-disable max-len */
/**
 * A component that renders a yes/no radio button choice.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the radio inputs.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper fieldset.
 * @param {string} [props.labelClasses] - Additional CSS classes for the legend.
 * @param {string} props.name - The name of the input, used for form submission.
 * @param {string} props.label - The text to display for the legend.
 * @param {Array<object>} props.options - An array of option objects, typically 'Yes' and 'No'.
 * @param {number} props.options[].id - The unique ID of the option.
 * @param {string} props.options[].optionLabel - The label for the option (e.g., 'Yes').
 * @param {boolean} props.options[].selected - Whether the option is selected.
 * @param {function(id: number, checked: boolean): void} props.handleRadioChange - The function to call when a radio button is changed.
 */
/* eslint-enable max-len */
export const YesNo = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  name,
  label,
  options,
  handleRadioChange,
}) => {

  return (
    <fieldset
      className={clsx(wrapperClasses, 'custom-form-field--yes-no')}
    >
      <legend
        className={labelClasses}
      >
        {label}
      </legend>
      <div className="custom-form-field__options-list">
        {options.map(({ id, optionLabel, selected }, index) => (
          <div className="custom-form-field__option">
            <input
              key={`yes-no-${id}--${index}`}
              id={`yes-no-${id}--${index}`}
              type="radio"
              name={name}
              value={optionLabel}
              checked={selected}
              onChange={(e) => handleRadioChange(id, e.target.checked)}
              className={clsx(inputClasses)}
            />
            <label
              htmlFor={`yes-no-${id}--${index}`}
            >
              {optionLabel}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  );
};
